import { render, staticRenderFns } from "./AnonymousProfileRequests.vue?vue&type=template&id=30447454"
import script from "./AnonymousProfileRequests.vue?vue&type=script&lang=js"
export * from "./AnonymousProfileRequests.vue?vue&type=script&lang=js"
import style0 from "./AnonymousProfileRequests.vue?vue&type=style&index=0&id=30447454&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports